module.exports = __webpack_public_path__ + "img/three.b65d052b.svg";